 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import { useEffect} from 'react'
import {readInlineData} from 'relay-runtime'

import {RetroDemo} from '../types/constEnums'
import findKeyByValue from '../utils/findKeyByValue'
import findStageById from '../utils/meetings/findStageById'
import fromStageIdToUrl from '../utils/meetings/fromStageIdToUrl'
import getMeetingPathParams from '../utils/meetings/getMeetingPathParams'
import {phaseTypeToSlug} from '../utils/meetings/lookups'
import updateLocalStage from '../utils/relay/updateLocalStage'

import useAtmosphere from './useAtmosphere'
import useRouter from './useRouter'

const useInitialSafeRoute = (
  setSafeRoute,
  meetingRef
) => {
  const atmosphere = useAtmosphere()
  const {history} = useRouter()
  const meeting = readInlineData(
    graphql`
      fragment useInitialSafeRoute_meeting on NewMeeting @inline {
        ...fromStageIdToUrl_meeting
        ...updateLocalStage_meeting
        id
        meetingType
        facilitatorStageId
        facilitatorUserId
        localStage {
          id
        }
        localPhase {
          id
          stages {
            id
          }
        }
        phases {
          id
          phaseType
          stages {
            id
            isNavigable
            isNavigableByFacilitator
          }
        }
      }
    `,
    meetingRef
  )

  useEffect(
    () => {
      const meetingPath = getMeetingPathParams()
      const {phaseSlug, stageIdxSlug} = meetingPath
      if (!meeting) {
        // We should not reach this as we should filter out inaccessible meetings in MeetingSelector
        setSafeRoute(false)
        return
      }
      const {facilitatorStageId, facilitatorUserId, localStage, id: meetingId, phases} = meeting
      const {viewerId} = atmosphere

      // I’m headed to the lobby but the meeting is already going, send me there
      if (localStage && !phaseSlug) {
        const {id: localStageId} = localStage
        const nextUrl = fromStageIdToUrl(localStageId, meeting)
        history.replace(nextUrl)
        updateLocalStage(atmosphere, meeting, facilitatorStageId)
        setSafeRoute(false)
        return
      }

      const localPhaseType = findKeyByValue(phaseTypeToSlug, phaseSlug )
      const stageIdx = stageIdxSlug ? Number(stageIdxSlug) - 1 : 0
      const phase = phases.find((curPhase) => curPhase.phaseType === localPhaseType)

      // typo in url, send to the facilitator
      if (!phase) {
        const nextUrl = fromStageIdToUrl(facilitatorStageId, meeting)
        history.replace(nextUrl)
        updateLocalStage(atmosphere, meeting, facilitatorStageId)
        setSafeRoute(false)
        return
      }

      const stage = phase.stages[stageIdx]
      const stageId = _optionalChain([stage, 'optionalAccess', _ => _.id])
      const isViewerFacilitator = viewerId === facilitatorUserId
      const itemStage = stageId && findStageById(phases, stageId)
      if (!itemStage) {
        // useful for e.g. /discuss/2, especially on the demo
        const nextUrl =
          meetingId === RetroDemo.MEETING_ID
            ? '/retrospective-demo/reflect'
            : fromStageIdToUrl(facilitatorStageId, meeting)
        updateLocalStage(atmosphere, meeting, facilitatorStageId)
        history.replace(nextUrl)
        setSafeRoute(false)
        return
      }
      // const {stage} = itemStage
      const {isNavigable, isNavigableByFacilitator} = stage
      const canNavigate = isViewerFacilitator ? isNavigableByFacilitator : isNavigable
      if (!canNavigate) {
        // too early to visit meeting or typo, go to facilitator
        const nextUrl = fromStageIdToUrl(facilitatorStageId, meeting)
        history.replace(nextUrl)
        updateLocalStage(atmosphere, meeting, facilitatorStageId)
        setSafeRoute(false)
        return
      }

      // legit URL!
      updateLocalStage(atmosphere, meeting, stage.id)
      setSafeRoute(true)
    },
    [
      /* eslint-disable-line react-hooks/exhaustive-deps */
    ]
  )
}

export default useInitialSafeRoute
